export default __webpack_public_path__ + "static/media/logo.93dea91e.png";